module.exports = __webpack_public_path__ + "static/media/YF29_2.40325bd3.jpg";